import { useSearchStore } from '@stores/search.store'

import { JobSearch } from '@types'

import { useShallow } from 'zustand/react/shallow'

import Button from '@components/buttons/button'
import SalaryInput from '@components/inputs/salary-input'
import useSearchDispatcher from '@hooks/useSearchDispatcher'
import { serpFiltersUpdatedEvent } from '@lib/analytics-events'

import styles from '../index.module.scss'
import Filter from './job-type-filters'

import type { JSX } from 'react'

export default function SearchForm({ search }: { search: JobSearch }): JSX.Element {
  const [nextSearch, addParamsToSearch] = useSearchStore(
    useShallow((state) => [state.nextSearch, state.addParamsToSearch]),
  )
  const searchDispatcher = useSearchDispatcher()

  const openSearch = (): void => {
    serpFiltersUpdatedEvent(nextSearch)
    searchDispatcher({ page: 1 })
  }

  return (
    <div className={styles['refine-search']}>
      <div className={styles.title}>Refine your job search</div>
      <form
        autoComplete="off"
        onSubmit={(e): void => {
          e.preventDefault()
          e.stopPropagation()
          openSearch()
        }}
      >
        <Filter search={search} />
        <SalaryInput
          value={nextSearch.salary.min || 0}
          onChange={(value): void => addParamsToSearch({ salary: { min: value, type: 'PER_ANNUM' } })}
        />
        <Button variant="yellow" size="lg">
          Update
        </Button>
      </form>
    </div>
  )
}
